module.exports = __webpack_public_path__ + "static/media/test4_1.e87a5c31.png";